import type { InternalAxiosRequestConfig } from 'axios';
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  isMobile,
  isBrowser,
  isDesktop,
} from 'react-device-detect';

import { version } from '../../../package.json';

export default function deviceInfoInterceptor(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  config.headers.set(
    'AppInfo',
    JSON.stringify({
      appVersion: version,
      platform: 'WEB',
      platformVersion: `${browserName} ${browserVersion}`,
      extra: {
        os: `${osName} ${osVersion}`,
        isMobile,
        isBrowser,
        isDesktop,
      },
      // pointControl: 'WebTeste',
    }),
  );

  return config;
}
